module.exports = __webpack_public_path__ + "static/tractorzoom-logo@3x-9b49c3f5943f7ac9afce9aebd59c3e1b.png";